import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SpatialTrackingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"spatial_tracking"}/>
}
